var jQuery            = require('jquery');
var mobileTourContent = require('ub/ui/alert-dialog/mobile-tour').default;

var MobileTourTemplateBuilder = function() {};

MobileTourTemplateBuilder.prototype.beforeRender = function() {};

MobileTourTemplateBuilder.prototype.render = function(onClose) {
  var mainPage = window.editor.mainPage;

  if(mainPage.getConfigValue('showTour')) {
    mobileTourContent({
      displayNameCapitalized: mainPage.getConfigValue('displayName'),
      displayNameLowerCase: mainPage.getConfigValue('displayNameLowerCase'),
      showOverlaySEOWarning: mainPage.getConfigValue('showOverlaySEOWarning'),
      useConvertablesMobileTour: mainPage.getConfigValue('useConvertablesMobileTour'),
      onClose: onClose
    }).safeOpen();
  }
};

MobileTourTemplateBuilder.prototype.afterRender = function() {
  var slides             = jQuery('.alert-modal .overlay-slide')
    , navdots            = jQuery('.alert-modal .nav-dots .dot')
    , backButton         = jQuery('.alert-modal .action-bar .back')
    , continueButton     = jQuery('.alert-modal .action-bar .continue')
    , continueButtonSpan = continueButton.find('span')
    , totalSlides        = slides.length - 1
    , currentSlide       = 0;

  var updateContinueButton = function() {
    if (currentSlide === (totalSlides)) {
      continueButtonSpan.text('Done');
    } else {
      continueButtonSpan.text('Continue');
    }
  };

  navdots.click(function() {
    var index = jQuery(this).index();

    jQuery(slides[currentSlide]).removeClass('in');
    var i;
    if(currentSlide < index){
      for(i = currentSlide; i < index; i++){
        jQuery(slides[i]).addClass('out');
      }
    }else{
      for(i = currentSlide; i>=index; i--){
        jQuery(slides[i]).removeClass('out');
      }
    }
    jQuery(slides[index]).addClass('in');
    jQuery(navdots).removeClass('active');
    jQuery(navdots[index]).addClass('active');
    if(index === 0){
      backButton.addClass('dsbl');
    }else{
      backButton.removeClass('dsbl');
    }
    currentSlide = index;

    updateContinueButton();
  });

  continueButton.click(function() {
    backButton.removeClass('dsbl');

    if (currentSlide === totalSlides) {
      window.editor.dialogManager.closeCurrentDialog();
    } else {
      jQuery(slides[currentSlide]).removeClass('in').addClass('out');
      jQuery(slides[currentSlide+1]).addClass('in');

      jQuery(navdots[currentSlide]).removeClass('active');
      jQuery(navdots[currentSlide+1]).addClass('active');
      currentSlide++;
    }

    updateContinueButton();

  });

  backButton.click(function(){
    if(currentSlide > 0){
      if(currentSlide === 1){
        backButton.addClass('dsbl');
      }else{
        backButton.removeClass('dsbl');
      }

      jQuery(slides[currentSlide]).removeClass('in');
      jQuery(slides[currentSlide-1]).removeClass('out').addClass('in');

      jQuery(navdots[currentSlide]).removeClass('active');
      jQuery(navdots[currentSlide-1]).addClass('active');

      currentSlide--;

      updateContinueButton();
    }
  });

};

module.exports = MobileTourTemplateBuilder;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/new-feature-tour/mobile-tour-template-builder.js
// module id = 1054
// module chunks = 0